// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.siteHeader__wrapper {
	position: relative;
	height: 100%;
	max-width: 1440px;
	display: flex;
	margin: 0;
	padding: 0;
	overflow: hidden
}
li.horizontalNavigation__list-item > button.activeTab{
	background: linear-gradient(135deg, #00d5fd 0%, #0495ff 50%, #0072ee 100%) !important;
	color: #ffffff !important;
	border-bottom: none;
	border-radius: 4px 4px 0 0;
	box-shadow: 0 4px 12px rgba(0, 180, 220, 0.35);
	transition: all 0.2s ease;
}
.siteHeader__row {
	width: 100%;
	position: relative;
	z-index: 10;
	margin-top: 8px;
}
.siteHeader .horizontalNavigation {
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: flex-start;
	flex-wrap: wrap;
	flex-direction: row;
	padding: 0 20px;
}
@media (min-height: 768px) {
	.siteHeader .horizontalNavigation {
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		flex-wrap: nowrap;
		flex-direction: row;
		padding: 0 20px;
	}
}
.siteHeader .horizontalNavigation__list {
	position: relative;
	display: flex;
	flex-wrap: wrap;
	flex-direction: row;
	margin: 0;
	padding: 0;
	gap: 4px;
}
.siteHeader .horizontalNavigation__list-item{
	list-style-type: none;
	width: 170px;
	text-align: center;
	outline: none;
	border: 1px solid #a0d8ef;
	background: linear-gradient(135deg, #e8f7fc 0%, #cdf0f8 100%);
	border-radius: 4px 4px 0 0;
	margin-right: 0;
	transition: background 0.2s ease;
}
.siteHeader .horizontalNavigation__list-item:hover{
	background: linear-gradient(135deg, #c8eef8 0%, #a0e0f5 100%);
}
.siteHeader .navigation__link {
	padding: 0 12px;
	margin: 0;
	background: transparent;
	border-radius: 4px 4px 0 0;
	border: 0;
	outline: none;
	position: relative;
	display: inline-block;
	width: 100%;
	height: 100%;
	letter-spacing: 0;
	line-height: 44px;
	cursor: pointer;
	font-family: "Segoe UI" !important;
}
.siteHeader .navigation__link-indicator {
	height: 2px;
	width: 170px;
	background: #F15725;
	position: absolute;
	left: 0;
	bottom: 0;
	pointer-events: none;
	transform-origin: left;
	transition: transform .35s cubic-bezier(0, 0, .16, .96);
	transform: translateX(0) scale(0)
}
.siteHeader .navigation__link-text{
	font-weight: 500;
	font-size: var(--subheader);
	line-height: 20px;
	color: #2a3a42;
	transition: color 0.2s ease;
}
li.horizontalNavigation__list-item > button.activeTab .navigation__link-text {
	color: #ffffff !important;
	font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/components/App/components/ModulesMenu.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;CAClB,YAAY;CACZ,iBAAiB;CACjB,aAAa;CACb,SAAS;CACT,UAAU;CACV;AACD;AACA;CACC,qFAAqF;CACrF,yBAAyB;CACzB,mBAAmB;CACnB,0BAA0B;CAC1B,8CAA8C;CAC9C,yBAAyB;AAC1B;AACA;CACC,WAAW;CACX,kBAAkB;CAClB,WAAW;CACX,eAAe;AAChB;AACA;CACC,YAAY;CACZ,aAAa;CACb,mBAAmB;CACnB,2BAA2B;CAC3B,eAAe;CACf,mBAAmB;CACnB,eAAe;AAChB;AACA;CACC;EACC,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;CAChB;AACD;AACA;CACC,kBAAkB;CAClB,aAAa;CACb,eAAe;CACf,mBAAmB;CACnB,SAAS;CACT,UAAU;CACV,QAAQ;AACT;AACA;CACC,qBAAqB;CACrB,YAAY;CACZ,kBAAkB;CAClB,aAAa;CACb,yBAAyB;CACzB,6DAA6D;CAC7D,0BAA0B;CAC1B,eAAe;CACf,gCAAgC;AACjC;AACA;CACC,6DAA6D;AAC9D;AACA;CACC,eAAe;CACf,SAAS;CACT,uBAAuB;CACvB,0BAA0B;CAC1B,SAAS;CACT,aAAa;CACb,kBAAkB;CAClB,qBAAqB;CACrB,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,iBAAiB;CACjB,eAAe;CACf,kCAAkC;AACnC;AACA;CACC,WAAW;CACX,YAAY;CACZ,mBAAmB;CACnB,kBAAkB;CAClB,OAAO;CACP,SAAS;CACT,oBAAoB;CACpB,sBAAsB;CACtB,uDAAuD;CACvD;AACD;AACA;CACC,gBAAgB;CAChB,2BAA2B;CAC3B,iBAAiB;CACjB,cAAc;CACd,2BAA2B;AAC5B;AACA;CACC,yBAAyB;CACzB,gBAAgB;AACjB","sourcesContent":[".siteHeader__wrapper {\n\tposition: relative;\n\theight: 100%;\n\tmax-width: 1440px;\n\tdisplay: flex;\n\tmargin: 0;\n\tpadding: 0;\n\toverflow: hidden\n}\nli.horizontalNavigation__list-item > button.activeTab{\n\tbackground: linear-gradient(135deg, #00d5fd 0%, #0495ff 50%, #0072ee 100%) !important;\n\tcolor: #ffffff !important;\n\tborder-bottom: none;\n\tborder-radius: 4px 4px 0 0;\n\tbox-shadow: 0 4px 12px rgba(0, 180, 220, 0.35);\n\ttransition: all 0.2s ease;\n}\n.siteHeader__row {\n\twidth: 100%;\n\tposition: relative;\n\tz-index: 10;\n\tmargin-top: 8px;\n}\n.siteHeader .horizontalNavigation {\n\theight: 100%;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-start;\n\tflex-wrap: wrap;\n\tflex-direction: row;\n\tpadding: 0 20px;\n}\n@media (min-height: 768px) {\n\t.siteHeader .horizontalNavigation {\n\t\theight: 100%;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: flex-start;\n\t\tflex-wrap: nowrap;\n\t\tflex-direction: row;\n\t\tpadding: 0 20px;\n\t}\n}\n.siteHeader .horizontalNavigation__list {\n\tposition: relative;\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\tflex-direction: row;\n\tmargin: 0;\n\tpadding: 0;\n\tgap: 4px;\n}\n.siteHeader .horizontalNavigation__list-item{\n\tlist-style-type: none;\n\twidth: 170px;\n\ttext-align: center;\n\toutline: none;\n\tborder: 1px solid #a0d8ef;\n\tbackground: linear-gradient(135deg, #e8f7fc 0%, #cdf0f8 100%);\n\tborder-radius: 4px 4px 0 0;\n\tmargin-right: 0;\n\ttransition: background 0.2s ease;\n}\n.siteHeader .horizontalNavigation__list-item:hover{\n\tbackground: linear-gradient(135deg, #c8eef8 0%, #a0e0f5 100%);\n}\n.siteHeader .navigation__link {\n\tpadding: 0 12px;\n\tmargin: 0;\n\tbackground: transparent;\n\tborder-radius: 4px 4px 0 0;\n\tborder: 0;\n\toutline: none;\n\tposition: relative;\n\tdisplay: inline-block;\n\twidth: 100%;\n\theight: 100%;\n\tletter-spacing: 0;\n\tline-height: 44px;\n\tcursor: pointer;\n\tfont-family: \"Segoe UI\" !important;\n}\n.siteHeader .navigation__link-indicator {\n\theight: 2px;\n\twidth: 170px;\n\tbackground: #F15725;\n\tposition: absolute;\n\tleft: 0;\n\tbottom: 0;\n\tpointer-events: none;\n\ttransform-origin: left;\n\ttransition: transform .35s cubic-bezier(0, 0, .16, .96);\n\ttransform: translateX(0) scale(0)\n}\n.siteHeader .navigation__link-text{\n\tfont-weight: 500;\n\tfont-size: var(--subheader);\n\tline-height: 20px;\n\tcolor: #2a3a42;\n\ttransition: color 0.2s ease;\n}\nli.horizontalNavigation__list-item > button.activeTab .navigation__link-text {\n\tcolor: #ffffff !important;\n\tfont-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
